export default __webpack_public_path__ + "static/media/calendar_checK.dde47179.svg";